import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { Spin, message, Select,DatePicker } from "antd";
import Bridge from "./utils/Bridge";
import { ECAS_FORM_TYPES } from "./utils/consts";
import moment from 'moment';
import dayjs from 'dayjs';

const { Option } = Select

export default class AddPhysicalEcasForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      old_password: "",
      new_password: "",
      confirm_password: "",
      confirm_type: "password",
      new_type: "password",
      old_type: "password",
      loading: false,
      ecas_form_type:[],
      date:null,
      form_pdf:[],
      naming_score:'',
      comprehension_score:'',
      spelling_score:'',
      langauge_score:'',
      fluency_letter_s_score:'',
      fluency_letter_t_score:'',
      verbal_fluency_score:'',
      reverse_digit_span_score:'',
      alternation_score:'',
      sentence_completion_score:'',
      social_cognition_score:'',
      executive_score:'',
      immediate_recall_score:'',
      delayed_recall_score:'',
      delayed_recognition_score:'',
      memory_score:'',
      dot_counting_score:'',
      cube_counting_score:'',
      number_location_score:'',
      visuospatial_score:'',
    };
  }
  componentDidMount() {}
  save_form = () => {
    if (this.state.ecas_form_type.length==0) {
      message.warning("Please select form type.");
      return;
    } else if (!this.state.date) {
      message.warning("Please select date.");
      return;
    }

    // Require either a PDF form or at least one score field to be present
    const hasFormPdf = this.state.form_pdf && this.state.form_pdf.length > 0;
    
    // Check if at least one score field has a valid value (excluding readonly calculated fields)
    const scoreFields = [
      "naming_score",
      "comprehension_score",
      "spelling_score",
      "fluency_letter_s_score",
      "fluency_letter_t_score",
      "reverse_digit_span_score",
      "alternation_score",
      "sentence_completion_score",
      "social_cognition_score",
      "immediate_recall_score",
      "delayed_recall_score",
      "delayed_recognition_score",
      "dot_counting_score",
      "cube_counting_score",
      "number_location_score"
    ];
    
    const hasScore = scoreFields.some(key => {
      const value = this.state[key];
      return value !== "" && 
             value !== null && 
             value !== undefined &&
             !isNaN(value) &&
             value.toString().trim() !== "";
    });

    if (!hasFormPdf && !hasScore) {
      message.warning("Please upload a PDF file or fill in at least one score field.");
      return;
    }
   
    if (Number(this.state.naming_score)<0==true ||
      Number(this.state.naming_score)>100==true
    ) {
      message.warning("Please enter correct value for naming score");
      return;
    } 
    if (Number(this.state.comprehension_score)<0==true ||
      Number(this.state.comprehension_score)>100==true
    ) {
      message.warning("Please enter correct value for comprehension score");
      return;
    } 
    if (Number(this.state.spelling_score)<0==true ||
      Number(this.state.spelling_score)>100==true
    ) {
      message.warning("Please enter correct value for spelling score");
      return;
    } 
    if (Number(this.state.fluency_letter_s_score)<0==true ||
      Number(this.state.fluency_letter_s_score)>100==true
    ) {
      message.warning("Please enter correct value for fluency letter S score");
      return;
    } 
    if (Number(this.state.fluency_letter_t_score)<0==true ||
      Number(this.state.fluency_letter_t_score)>100==true
    ) {
      message.warning("Please enter correct value for fluency letter T score");
      return;
    } 
    if (Number(this.state.reverse_digit_span_score)<0==true ||
      Number(this.state.reverse_digit_span_score)>100==true
    ) {
      message.warning("Please enter correct value for reverse digit span score");
      return;
    } 
    if (Number(this.state.alternation_score)<0==true ||
      Number(this.state.alternation_score)>100==true
    ) {
      message.warning("Please enter correct value for alternation score");
      return;
    } 
    if (Number(this.state.sentence_completion_score)<0==true ||
      Number(this.state.sentence_completion_score)>100==true
    ) {
      message.warning("Please enter correct value for sentence completion score");
      return;
    } 
    if (Number(this.state.social_cognition_score)<0==true ||
      Number(this.state.social_cognition_score)>100==true
    ) {
      message.warning("Please enter correct value for social cognition score");
      return;
    } 
    if (Number(this.state.immediate_recall_score)<0==true ||
      Number(this.state.immediate_recall_score)>100==true
    ) {
      message.warning("Please enter correct value for immediate recall score");
      return;
    } 
    if (Number(this.state.delayed_recall_score)<0==true ||
      Number(this.state.delayed_recall_score)>100==true
    ) {
      message.warning("Please enter correct value for delayed recall score");
      return;
    } 
    if (Number(this.state.delayed_recognition_score)<0==true ||
      Number(this.state.delayed_recognition_score)>100==true
    ) {
      message.warning("Please enter correct value for delayed recognition score");
      return;
    } 
    if (Number(this.state.dot_counting_score)<0==true ||
      Number(this.state.dot_counting_score)>100==true
    ) {
      message.warning("Please enter correct value for dot counting score");
      return;
    } 
    if (Number(this.state.cube_counting_score)<0==true ||
      Number(this.state.cube_counting_score)>100==true
    ) {
      message.warning("Please enter correct value for cube counting score");
      return;
    } 
    if (Number(this.state.number_location_score)<0==true ||
      Number(this.state.number_location_score)>100==true
    ) {
      message.warning("Please enter correct value for number location score");
      return;
    } 
   
   

    let formData=new FormData();
    formData.append('form_type', JSON.stringify(this.state.ecas_form_type))
    formData.append('date', this.state.date)
    if(this.state.form_pdf.length>0){
      for(let i=0; i<this.state.form_pdf.length; i++){
        formData.append('files[]', this.state.form_pdf[i])
      }
    }
   
    formData.append('naming_score', this.state.naming_score)
    formData.append('comprehension_score', this.state.comprehension_score)
    formData.append('spelling_score', this.state.spelling_score)
    formData.append('langauge_score', this.state.langauge_score)
    formData.append('fluency_letter_s_score', this.state.fluency_letter_s_score)
    formData.append('fluency_letter_t_score', this.state.fluency_letter_t_score)
    formData.append('verbal_fluency_score', this.state.verbal_fluency_score)
    formData.append('reverse_digit_span_score', this.state.reverse_digit_span_score)
    formData.append('alternation_score', this.state.alternation_score)
    formData.append('sentence_completion_score', this.state.sentence_completion_score)
    formData.append('social_cognition_score', this.state.social_cognition_score)
    formData.append('executive_score', this.state.executive_score)
    formData.append('immediate_recall_score', this.state.immediate_recall_score)
    formData.append('delayed_recall_score', this.state.delayed_recall_score)
    formData.append('delayed_recognition_score', this.state.delayed_recognition_score)
    formData.append('memory_score', this.state.memory_score)
    formData.append('dot_counting_score', this.state.dot_counting_score)
    formData.append('cube_counting_score', this.state.cube_counting_score)
    formData.append('number_location_score', this.state.number_location_score)
    formData.append('visuospatial_score', this.state.visuospatial_score)
    formData.append('eals_id', localStorage.getItem("ap_eals_id"))
   
    this.setState({ loading: true });
    Bridge.personal_data_viewer.ecas_study.save_physical_ecas_form(formData)
      .then((response) => {
     
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState({
            loading: false,
          },()=>{
            setTimeout(() => {
              window.location.assign("/my-personal-data-viewer");
            }, 2000);
          });
        } else {
          message.warning(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.error("Please try againdf!!");
        this.setState({ loading: false });
      });
  };
  onChangeDate = (date, dateString) => {
    this.setState({  date: dateString })
  };
  calculateLanguageScore = () => {
    const naming = Number(this.state.naming_score) || 0;
    const comprehension = Number(this.state.comprehension_score) || 0;
    const spelling = Number(this.state.spelling_score) || 0;
    const total = naming + comprehension + spelling;
    this.setState({ langauge_score: total });
  };
  calculateVerbalFluencyScore = () => {
    const fluencyS = Number(this.state.fluency_letter_s_score) || 0;
    const fluencyT = Number(this.state.fluency_letter_t_score) || 0;
    const total = fluencyS + fluencyT;
    this.setState({ verbal_fluency_score: total });
  };
  calculateExecutiveScore = () => {
    const reverseDigitSpan = Number(this.state.reverse_digit_span_score) || 0;
    const alternation = Number(this.state.alternation_score) || 0;
    const sentenceCompletion = Number(this.state.sentence_completion_score) || 0;
    const socialCognition = Number(this.state.social_cognition_score) || 0;
    const total = reverseDigitSpan + alternation + sentenceCompletion + socialCognition;
    this.setState({ executive_score: total });
  };
  calculateMemoryScore = () => {
    const immediateRecall = Number(this.state.immediate_recall_score) || 0;
    const delayedRecall = Number(this.state.delayed_recall_score) || 0;
    const delayedRecognition = Number(this.state.delayed_recognition_score) || 0;
    const total = immediateRecall + delayedRecall + delayedRecognition;
    this.setState({ memory_score: total });
  };
  calculateVisuospatialScore = () => {
    const dotCounting = Number(this.state.dot_counting_score) || 0;
    const cubeCounting = Number(this.state.cube_counting_score) || 0;
    const numberLocation = Number(this.state.number_location_score) || 0;
    const total = dotCounting + cubeCounting + numberLocation;
    this.setState({ visuospatial_score: total });
  };
  render() {
    return (
      <div>
        <Header />
        <div
          className="main-content demographics-wrapper physical_ecas_form"
          style={{ paddingTop: 40 }}
        >
          <div className="container" style={{ minHeight: 300 }}>
            <div className="row">
              <div className="col-lg-6">
                <a href="/my-personal-data-viewer" style={{width:95}} className="dashboard-back-arrow mt-0">
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Back
                </a>
                <Spin spinning={this.state.loading}>
                  <div className="change-password-form">
                    <h3 className="pb-0 mb-0">Upload ECAS Form</h3>
                    <hr />
                    <div className="form-group pt-4 mb-4">
                      <label className="input-heading mb-2">
                        Form Type <span className="text-danger">*</span> 
                      </label>
                      <Select
                        value={this.state.ecas_form_type}
                        style={{width:"100%",height:48}}
                        onChange={(e) =>
                          this.setState({ ecas_form_type: e })
                        }
                        mode="multiple"
                        allowClear
                      >
                        {ECAS_FORM_TYPES.map((item,index)=>{
                          return (
                            <Option value={item} key={index}>{item}</Option>
                          )
                        })}
                      </Select>
                    </div>
                    <div className="form-group mb-4">
                      <label className="input-heading mb-2">
                        Date <span className="text-danger">*</span> 
                      </label>
                      <DatePicker 
                        onChange={this.onChangeDate} 
                        format="MM/DD/YYYY"
                        style={{width:"100%"}}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label className="input-heading mb-2">
                        File &nbsp;
                      </label>
                      <input
                        type={'file'}
                        onChange={(e) =>{
                          this.setState({ form_pdf: e.target.files })
                        }}
                        className="form-control"
                        style={{padding:"11px 22px"}}
                        multiple={true}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label className="input-heading mb-2">
                        Scores
                      </label>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Naming Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.naming_score}
                          onChange={(e) =>{
                            this.setState({ naming_score: e.target.value }, () => {
                              this.calculateLanguageScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Comprehension Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.comprehension_score}
                          onChange={(e) =>{
                            this.setState({ comprehension_score: e.target.value }, () => {
                              this.calculateLanguageScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Spelling Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.spelling_score}
                          onChange={(e) =>{
                            this.setState({ spelling_score: e.target.value }, () => {
                              this.calculateLanguageScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Language Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.langauge_score}
                          readOnly
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100,backgroundColor:"#f5f5f5"}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <hr style={{marginTop: 0}} />
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Fluency Letter S Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.fluency_letter_s_score}
                          onChange={(e) =>{
                            this.setState({ fluency_letter_s_score: e.target.value }, () => {
                              this.calculateVerbalFluencyScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Fluency Letter T Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.fluency_letter_t_score}
                          onChange={(e) =>{
                            this.setState({ fluency_letter_t_score: e.target.value }, () => {
                              this.calculateVerbalFluencyScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                        Verbal Fluency Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.verbal_fluency_score}
                          readOnly
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100,backgroundColor:"#f5f5f5"}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <hr style={{marginTop: 0}} />
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Reverse Digit Span Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.reverse_digit_span_score}
                          onChange={(e) =>{
                            this.setState({ reverse_digit_span_score: e.target.value }, () => {
                              this.calculateExecutiveScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Alternation Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.alternation_score}
                          onChange={(e) =>{
                            this.setState({ alternation_score: e.target.value }, () => {
                              this.calculateExecutiveScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Sentence Completion Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.sentence_completion_score}
                          onChange={(e) =>{
                            this.setState({ sentence_completion_score: e.target.value }, () => {
                              this.calculateExecutiveScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Social Cognition Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.social_cognition_score}
                          onChange={(e) =>{
                            this.setState({ social_cognition_score: e.target.value }, () => {
                              this.calculateExecutiveScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                        Executive Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.executive_score}
                          readOnly
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100,backgroundColor:"#f5f5f5"}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <hr style={{marginTop: 0}} />
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Immediate Recall Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.immediate_recall_score}
                          onChange={(e) =>{
                            this.setState({ immediate_recall_score: e.target.value }, () => {
                              this.calculateMemoryScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Delayed Recall Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.delayed_recall_score}
                          onChange={(e) =>{
                            this.setState({ delayed_recall_score: e.target.value }, () => {
                              this.calculateMemoryScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Delayed Recognition Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.delayed_recognition_score}
                          onChange={(e) =>{
                            this.setState({ delayed_recognition_score: e.target.value }, () => {
                              this.calculateMemoryScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                        Memory Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.memory_score}
                          readOnly
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100,backgroundColor:"#f5f5f5"}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <hr style={{marginTop: 0}} />
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Dot Counting Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.dot_counting_score}
                          onChange={(e) =>{
                            this.setState({ dot_counting_score: e.target.value }, () => {
                              this.calculateVisuospatialScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Cube Counting Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.cube_counting_score}
                          onChange={(e) =>{
                            this.setState({ cube_counting_score: e.target.value }, () => {
                              this.calculateVisuospatialScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                          Number Location Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.number_location_score}
                          onChange={(e) =>{
                            this.setState({ number_location_score: e.target.value }, () => {
                              this.calculateVisuospatialScore();
                            })
                          }}
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100}}
                          min={0}
                          max={100}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-start">
                        <label className="input-heading mb-2">
                        Visuospatial Score
                        </label>
                        <input
                          type={'number'}
                          value={this.state.visuospatial_score}
                          readOnly
                          className="form-control"
                          style={{padding:"11px 22px",maxWidth:100,backgroundColor:"#f5f5f5"}}
                          min={0}
                          max={100}
                        />
                      </div>
                    </div>
                    <button
                      className="submit-button"
                      onClick={() => this.save_form()}
                    >
                      Submit{" "}
                      <box-icon
                        name="chevron-right"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                    </button>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
